import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=28b2c3cd&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=js&"
export * from "./Security.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2c3cd",
  null
  
)

export default component.exports